module.exports = __webpack_public_path__ + "img/tuomas1.1ee2db93.jpg";